export enum CalendarProvider {
  GOOGLE = 'google',
  // Add other providers as needed in the future
}
